import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { AlertService, AuthenticationService, ShadowService } from 'src/app/shared/_services';

@Component({
  selector: 'app-security-settings',
  templateUrl: './security-settings.page.html',
  styleUrls: ['./security-settings.page.scss'],
})
export class SecuritySettingsPage implements OnInit {
  currentUser: any;
  subscription: any;
  error: string;
  changePasswordForm: FormGroup;
  loading = false;
  disabled = true;
  showIcon = true;
  inputType = 'password';

  constructor(
    private formBuilder: FormBuilder, private router: Router,
    private auth: AuthenticationService, private alertService: AlertService,
    private shadowService: ShadowService, private platform: Platform
  ) {
    this.currentUser = this.auth.currentUserValue;
  }

  public errorMessages = {
    oldPassword: [
      { type: 'required', message: 'Current Password is required' },
      { type: 'minlength', message: 'Password too short' }
    ],
    newPassword: [
      { type: 'required', message: 'Password is required' },
      { type: 'minlength', message: 'Password too short' },
      { type: 'pattern', message: 'Password cannot be less than 8 characters' +
        ' and must contain a minimum of 1 Uppercase Letter, 1 Special Character and 1 Number'
      }
    ],
    confirmPassword: [
      { type: 'required', message: 'Please retype your current password' },
      { type: 'minlength', message: 'Password too short' },
      { type: 'pattern', message: 'Password cannot be less than 8 characters and must contain a minimum' +
        ' of 1 Uppercase Letter, 1 Special Character and 1 Number'
      }
    ]
  };

  get oldPassword() {
    return this.changePasswordForm.get('oldPassword');
  }

  get newPassword() {
    return this.changePasswordForm.get('newPassword');
  }

  get confirmPassword() {
    return this.changePasswordForm.get('confirmPassword');
  }

  togglePassword() {
    this.showIcon = !this.showIcon;
    this.inputType === 'password' ? this.inputType = 'text' : this.inputType = 'password';
  }

  passwordConfirm(formGroup: FormGroup) {
    const { value: newPassword } = formGroup.get('newPassword');
    const { value: confirmPassword } = formGroup.get('confirmPassword');
    return newPassword === confirmPassword ? null : { passwordNotMatch: true };
  }

  saveProfileDetails() {
    this.router.navigateByUrl('/dashboard');
  }

  changePassword() {
    this.error = null;
    if (this.changePasswordForm.invalid) {
      return;
    }

    this.loading = true;
    this.auth.changePassword(this.oldPassword.value, this.newPassword.value)
    .subscribe(
      (response: any) => {
        console.log(response);
        this.loading = false;
        this.alertService.standardAlert('Password changed successfully! Taking you to your Dashboard');
        setTimeout(() => {
          this.alertService.dismissAlert();
          this.router.navigate(['/dashboard']);
        }, 3000);
      },
      error => {
        console.log(error);
        this.error = error;
        this.loading = false;
        if (error.error.message.includes('Incorrect password')) {
          this.alertService.standardAlert('Your current password is incorrect');
        } else {
          this.alertService.standardAlert(error.error.message);
        }
      }
    );
  }

  goBack() {
    this.router.navigateByUrl('/profile');
  }

  ionViewDidEnter() {
    this.subscription = this.platform.backButton.subscribeWithPriority(99999, () => {
      this.goBack();
    });
  }

  ionViewWillEnter() {
    document.title = 'Security Settings | Bank3D';
    this.shadowService.button();
  }

  ionViewDidLeave() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.changePasswordForm = this.formBuilder.group({
      oldPassword: [
        '', [Validators.required, Validators.minLength(8), Validators.pattern('')]
      ],
      newPassword: [
        '', [Validators.required, Validators.minLength(8),
          Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$#"@$!%*?&])[A-Za-z\d$#"@$!%*?&].{7,}')]
      ],
      confirmPassword: [
        '', [Validators.required, Validators.minLength(8),
          Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$#"@$!%*?&])[A-Za-z\d$#"@$!%*?&].{7,}')]
      ],
    },
    {
      validators: this.passwordConfirm.bind(this)
    });
    window.addEventListener('keydown', (e) => {
      const pathname = window.location.pathname;
      if (e.key === 'Enter' && this.disabled === false && pathname.includes('security')) {
        this.changePassword();
      }
    });
  }
}
